import React, { useState } from 'react';
import Booking_tour_m from './booking_tour_m';
import Booking_tour_w from './booking_tour_w';

export default function Booking_tour(){
    const [selectedOption, setSelectedOption] = useState('');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };
    return (
        <div>
            <div className='hidden md:block '><Booking_tour_w /></div>
            <div className='md:hidden '><Booking_tour_m /></div>
        </div>
    )
}